// ENG-2119: with CP agreements on, a state's agreement is built in the CP document builder, so
// "Collaborating Physician" is offered only to show the type of a template that already has it.
export const templateTypeOptions = (currentType, cpAgreements) => [
  { value: "generic", label: "Generic" },
  { value: "provider", label: "Provider" },
  ...(!cpAgreements || currentType === "collab_physician"
    ? [{ value: "collab_physician", label: "Collaborating Physician" }]
    : []),
];
